module.exports = __webpack_public_path__ + "img/onboarding_pig.ed6d8d6c.svg";